import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Download } from 'lucide-react'
import WalletSelectionModal from './WalletSelectionModal'

interface WalletButtonsProps {
  passType: 'visit' | 'referral'
  className?: string
}

export const WalletButtons = ({ passType, className }: WalletButtonsProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  return (
    <div className={`flex flex-col items-center gap-3 ${className}`}>
      <Button
        onClick={handleOpenModal}
        className="flex items-center justify-center gap-2 bg-primary hover:bg-primary/90 text-primary-foreground px-6 py-3 rounded-lg font-semibold"
      >
        <Download className="h-5 w-5" />
        <span>Zu Wallet hinzufügen</span>
      </Button>
      
      <WalletSelectionModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        passType={passType}
      />
    </div>
  )
}

export default WalletButtons